import React from 'react'
import { Select, MenuItem, SelectChangeEvent } from '@mui/material'
import { CountryMetadata } from '../../../pure-js/libs/CountryHelper'
import styled from '@emotion/styled'

interface CountrySelectorProps {
  value: string
  onChange: (event: SelectChangeEvent<unknown>) => void
  countries: CountryMetadata[]
  disabled?: boolean
}

export const CountrySelector: React.FC<CountrySelectorProps> = ({ value, onChange, countries, disabled }) => {
  return (
    <StyledSelect
      value={value}
      onChange={onChange}
      disabled={disabled}
      renderValue={(selected) => {
        const country = countries.find((c) => c.code === selected)
        return (
          <CountryDisplay>
            <Flag>{country?.flag}</Flag>
          </CountryDisplay>
        )
      }}
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 400
          },
          sx: {
            '& .MuiMenuItem-root': {
              padding: '6px 12px',
              minHeight: 'auto'
            }
          }
        },
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        }
      }}
    >
      {countries.map((country) => (
        <MenuItem key={country.code} value={country.code}>
          <CountryOption>
            <Flag>{country.flag}</Flag>
            <CountryName>{country.name}</CountryName>
            <DialCode>{country.dialCode}</DialCode>
          </CountryOption>
        </MenuItem>
      ))}
    </StyledSelect>
  )
}

const StyledSelect = styled(Select)`
  min-width: 65px;
  margin-right: 0px;
  height: 40px;
  margin-top: 6px;

  .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.23);
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.87);
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #1976d2;
  }

  .MuiSelect-select {
    padding: 8px 32px 8px 8px;
  }
`

const CountryDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const CountryOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 2px 0;
`

const Flag = styled.span`
  font-size: 22px;
  line-height: 1;
  min-width: 22px;
`

const CountryName = styled.span`
  flex: 1;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const DialCode = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-left: auto;
  min-width: 42px;
  text-align: right;
`
